angular.module('request', ['ui.router','confirm.modal.html', 'ngResource', 'ngTable', 'ui.bootstrap']);

angular.module('request').config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {

    $stateProvider

    .state('request', {
        url         : "/request",
        parent      : 'app.admin',
        views: {
            'content':{
                templateUrl : server+"/views/m/request",
                controller  : 'request.list',
            }
        },
        ncyBreadcrumb: {
            parent: 'home',
            label: 'Request'
        }
    })

    .state('request_create', {
        url         : "/request/create",
        parent      : 'app.admin',
        views: {
            'content':{
                templateUrl : server+"/views/m/request/create",
                controller  : 'request.create',
            }
        },
        ncyBreadcrumb: {
            parent: 'request',
            label: 'Adicionar'
        }
    })

    .state('request_show', {
        url         : "/request/:id",
        parent      : 'app.admin',
        views: {
            'content':{
                templateUrl : server+"/views/m/request/show",
                controller  : 'request.show',
            }
        },
        ncyBreadcrumb: {
            parent: 'request',
            label: '{{request.id}}'
        }
    })

}]);

/**
 * List Controller
 */
angular.module('request').
controller('request.list', ['$scope', '$http', '$auth', '$q', 'NgTableParams', '$request', function($scope, $http, $auth, $q, NgTableParams, $request) {
    $scope.tableParams = new NgTableParams({
        page: 1,
        count: 10
    }, {
        counts: [],
        filterDelay: 0,
        getData: function(params) {
            return $request.query(params.url()).$promise.then(function(data) {
                params.total(data.total);
                return data.data;
            });
        }
    });
}]);

/**
 * Create Controller
 */
angular.module('request').
controller('request.create', ['$scope', '$state', '$request', function($scope, $state, $request) {
    $scope.save = function() {
        $request.save($scope.request).$promise.then(function(data) {
            $state.go('request_show', {
                id: data.id
            });
        });
    }
}]);

/**
 * Show, Edit, Delete Controller
 */
angular.module('request').
controller('request.show', ['$state', '$scope', '$stateParams', '$uibModal', '$request', function($state, $scope, $stateParams, $uibModal, $request) {

    $scope.editing = false;

    $scope.toggleEdit = function() {
        $scope.editing = !$scope.editing;
    }

    $request.get({
        id: $stateParams.id
    }).$promise.then(function(data) {
        $scope.request = data;
    }, function(error) {
        if (error.status == 404) {
            $state.go('notFound');
        }
    });

    $scope.confirmUpdate = function() {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'confirm.modal.html',
            size: 'sm',
            scope: $scope,
            controller: ['$scope', '$uibModalInstance', '$request', function($scope, $uibModalInstance, $request) {

                $scope.title = 'Deseja atualizar?';
                $scope.cancel_text = 'Cancelar';
                $scope.success_text = 'Concluído';

                var request = $scope.$parent.request;

                $scope.confirm = function() {
                    $request.update({
                        id: request.id
                    }, request).$promise.then(function(data) {
                        $uibModalInstance.dismiss('cancel');
                        $scope.$parent.toggleEdit();
                    })
                }

                $scope.cancel = function() {
                    $uibModalInstance.dismiss('cancel');
                };

            }]
        });
    };

    $scope.confirmDelete = function() {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'confirm.modal.html',
            size: 'sm',
            scope: $scope,
            controller: ['$state', '$scope', '$uibModalInstance', '$request', function($state, $scope, $uibModalInstance, $request) {

                $scope.title = 'Deseja remover esse registro?';
                $scope.cancel_text = 'Não';
                $scope.success_text = 'Sim';

                var request = $scope.$parent.request;

                $scope.confirm = function() {
                    $request.delete({id:request.id}).$promise.then(function(data){
                        $uibModalInstance.dismiss('cancel');
                        $state.go('request');
                    })
                }

                $scope.cancel = function() {
                    $uibModalInstance.dismiss('cancel');
                };

            }]
        });
    };

}]);


/**
 * Factory
 */
angular.module('request').
factory("$request", [ '$resource', function($resource) {
    var resource = $resource(api + 'request/:id', null, {
        'query': {
            method: 'GET',
            isArray: false
        },
        'update': {
            method: 'PUT'
        }
    });
    return resource;
}]);

angular.module("confirm.modal.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put('confirm.modal.html',
        '<div class="modal-body">' +
        ' {{title}}' +
        '</div>' +
        '<div class="modal-footer">' +
        '    <button class="btn btn-link btn-info" type="button" ng-click="cancel()">{{cancel_text}}</button>' +
        '    <button class="btn btn-outline btn-success" type="button" ng-click="confirm()">{{success_text}}</button>' +
        '</div>'
    );
}]);
